import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import AutoVatav from './auto-vatav/AutoVatavPage'
import { useEffect } from 'react'
import NormalEntry from './normal-entry/NormalEntry'


const PartyEntryPage = () => {
  const loginData: any = localStorage.getItem('branch')
  const currentUser = JSON.parse(loginData)
//   useEffect(() => {
//     // Set the title when the component mounts
//     const originalTitle = document.title; // Store the original title
    document.title = `PANEL - Party Entries`

//     // Cleanup: Revert to the original title (or a default) when unmounting
//     return () => {
//         document.title = originalTitle; // Or set a default like "My App"
//     }
// }, [currentUser.branch_name])
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            path='auto-vatav'
            element={
              <>
                <AutoVatav />
              </>
            }
          />
          <Route
            path='normal-entry'
            element={
              <>
                <NormalEntry />
              </>
            }
          />
        </Route>

        <Route index element={<Navigate to='/party-entry' />} />
      </Routes>
    </>
  )
}

export default PartyEntryPage
